// extracted by mini-css-extract-plugin
export default {"NEUTRAL_500":"#424242","panel":"panel-c41","visible":"visible-fd8","panel-content":"panel-content-f17","panel-header":"panel-header-e11"};